import { Alert, Grid, Tab, Tabs, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../../redux/slices/userSlice";
import ReceiptsTable from "./components/ReceiptsTable";
import {
  getAllProcessedReceipts,
  getAllUnprocessedReceipts,
} from "../../redux/slices/adminSlice";

const AdminReceiptsProcessing = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [pageNum, setPageNum] = useState(0);
  const [receiptsPerPage, setReceiptsPerPage] = useState(10);

  const allUnprocessedReceipts = useSelector(
    (state) => state.admin.allUnprocessedReceipts
  );
  const allProcessedReceipts = useSelector(
    (state) => state.admin.allProcessedReceipts
  );

  const [processedReceipts, setProcessedReceipts] = useState([]);
  const [unProcessedReceipts, setUnProcessedReceipts] = useState([]);

  const [tabValue, setTabValue] = useState(1);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
    getAllReceipts(newValue);
  };

  useEffect(() => {
    if (allUnprocessedReceipts) {
      setUnProcessedReceipts(allUnprocessedReceipts);
    }
  }, [allUnprocessedReceipts]);

  useEffect(() => {
    if (allProcessedReceipts) {
      setProcessedReceipts(allProcessedReceipts);
    }
  }, [allProcessedReceipts]);

  const getAllReceipts = (newValue) => {
    if (newValue === 1) {
      dispatch(getMe()).then(() =>
        dispatch(
          getAllUnprocessedReceipts({
            pageSize: receiptsPerPage,
            pageNum: pageNum + 1,
          })
        )
      );
    } else {
      dispatch(getMe()).then(() =>
        dispatch(
          getAllProcessedReceipts({
            pageSize: receiptsPerPage,
            pageNum: pageNum + 1,
          })
        )
      );
    }
  };
  const handleOnRowsPerPageChange = (value) => {
    setPageNum(0);
    setReceiptsPerPage(value);
  };
  const handleOnPageChange = (value) => {
    setPageNum(value);
  };
  useEffect(() => {
    dispatch(getMe()).then(() =>
      dispatch(
        getAllUnprocessedReceipts({
          pageSize: receiptsPerPage,
          pageNum: pageNum + 1,
        })
      )
    );
  }, [pageNum, receiptsPerPage, dispatch]);

  const handleOnProcessDataPageChange = (value) => {
    dispatch(getMe()).then(() =>
      dispatch(
        getAllProcessedReceipts({
          pageSize: receiptsPerPage,
          pageNum: value + 1,
        })
      )
    );
  };
  const handleOnProcessDataRowChange = (value) => {
    dispatch(getMe()).then(() =>
      dispatch(
        getAllProcessedReceipts({
          pageSize: value.pageSize,
          pageNum: value.page + 1,
        })
      )
    );
  };
  const handleOnSuccessUpdateReceipt = () => {
    getAllReceipts(1);
  }

  return (
    <Box padding="24px">
      <Stack direction="column">
        <Grid display="flex" justifyContent="center" padding="24px 0">
          <Typography variant="h5">{t("receiptsProcessing.title")}</Typography>
        </Grid>
        <Stack
          spacing={2}
          padding="8px"
          alignItems="center"
          direction="row"
          justifyContent="center"
        >
          <Alert severity="info">
            {t("receiptsProcessing.sortedDataInfo")}
          </Alert>
        </Stack>
        <Box sx={{ width: "100%" }}>
          <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="secondary tabs example"
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#F40002",
                height: 3,
              },
              "& .MuiTab-root.Mui-selected": {
                color: "#F40002",
              },
            }}
          >
            <Tab value={1} label={t("receiptsProcessing.unProcessed")} />
            <Tab value={2} label={t("receiptsProcessing.processed")} />
          </Tabs>
          {tabValue === 1 && (
            <ReceiptsTable
              data={unProcessedReceipts}
              onPageChange={handleOnPageChange}
              onChangeRowsPerPage={handleOnRowsPerPageChange}
              onSuccessUpdateReceipt={handleOnSuccessUpdateReceipt}
            />
          )}
          {tabValue === 2 && (
            <ReceiptsTable
              processedTableData
              data={processedReceipts}
              onProcessedDataPageChange={handleOnProcessDataPageChange}
              onProcessedDataRowChange={handleOnProcessDataRowChange}
            />
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default AdminReceiptsProcessing;
